export default __webpack_public_path__ + "static/sliding-rad-bce98c7d9811bccbdf8a64730fe9e41d.gif";